namespace TabAurous.Production {
    export interface SplittingItemsRow {
        TransItemId?: number;
        TransId?: number;
        RefVoucherNo?: string;
        OrderTypeId?: number;
        TransDate?: string;
        VoucherNo?: string;
        UserId?: number;
        BagNo?: string;
        SubBagNo?: number;
        LotNo?: string;
        Line_No?: number;
        DepartmentId?: number;
        CustomerId?: number;
        EmployeeId?: number;
        LedgerName?: string;
        RefTransId?: number;
        RefTransItemId?: number;
        RefVoucherId?: number;
        ProductId?: number;
        ProductCode?: string;
        ItemTypeId?: number;
        HasBom?: boolean;
        CalcOnId?: number;
        AttributeId?: number;
        Attribute?: string;
        KaratId?: number;
        MetalColorId?: number;
        Pieces?: number;
        Weight?: number;
        Parts?: number;
        NetWeight?: number;
        DiamondWeight?: number;
        DiamondPieces?: number;
        StoneWeight?: number;
        StonePieces?: number;
        OtherWeight?: number;
        OtherPieces?: number;
        Purity?: number;
        PureWeight?: number;
        DeliveryDate?: string;
        BOMDetails?: SplittingBOMRow[];
        StockAllocation?: boolean;
        TreeId?: number;
        TreeItemId?: number;
        TreeNo?: string;
    }

    export namespace SplittingItemsRow {
        export const idProperty = 'TransItemId';
        export const nameProperty = 'BagNo';
        export const localTextPrefix = 'Production.SplittingItems';
        export const lookupKey = 'Production.SplittingItems';

        export function getLookup(): Q.Lookup<SplittingItemsRow> {
            return Q.getLookup<SplittingItemsRow>('Production.SplittingItems');
        }
        export const deletePermission = 'Production:Splitting:Delete';
        export const insertPermission = 'Production:Splitting:Add';
        export const readPermission = '*';
        export const updatePermission = 'Production:Splitting:Edit';

        export declare const enum Fields {
            TransItemId = "TransItemId",
            TransId = "TransId",
            RefVoucherNo = "RefVoucherNo",
            OrderTypeId = "OrderTypeId",
            TransDate = "TransDate",
            VoucherNo = "VoucherNo",
            UserId = "UserId",
            BagNo = "BagNo",
            SubBagNo = "SubBagNo",
            LotNo = "LotNo",
            Line_No = "Line_No",
            DepartmentId = "DepartmentId",
            CustomerId = "CustomerId",
            EmployeeId = "EmployeeId",
            LedgerName = "LedgerName",
            RefTransId = "RefTransId",
            RefTransItemId = "RefTransItemId",
            RefVoucherId = "RefVoucherId",
            ProductId = "ProductId",
            ProductCode = "ProductCode",
            ItemTypeId = "ItemTypeId",
            HasBom = "HasBom",
            CalcOnId = "CalcOnId",
            AttributeId = "AttributeId",
            Attribute = "Attribute",
            KaratId = "KaratId",
            MetalColorId = "MetalColorId",
            Pieces = "Pieces",
            Weight = "Weight",
            Parts = "Parts",
            NetWeight = "NetWeight",
            DiamondWeight = "DiamondWeight",
            DiamondPieces = "DiamondPieces",
            StoneWeight = "StoneWeight",
            StonePieces = "StonePieces",
            OtherWeight = "OtherWeight",
            OtherPieces = "OtherPieces",
            Purity = "Purity",
            PureWeight = "PureWeight",
            DeliveryDate = "DeliveryDate",
            BOMDetails = "BOMDetails",
            StockAllocation = "StockAllocation",
            TreeId = "TreeId",
            TreeItemId = "TreeItemId",
            TreeNo = "TreeNo"
        }
    }
}
